export const startsWithHttps = (url: string) => url.startsWith('https');

export const FILE_UPLOAD_SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
];
